import { MappedClass, MappedProperty } from '@h5s/util-object';

@MappedClass()
export class BackendVersionInfo {
  @MappedProperty()
  version: string;
}
